export default ($section, data) => {
  const $video = $section.querySelector('#video-frame');
  const videoUrls = JSON.parse($section.querySelector('[data-videos]')?.textContent);
  let currentVideoIndex = 1;

  function updateDots() {
    const dots = $section.querySelectorAll('.dot');
    dots.forEach((dot) => dot.classList.remove('active'));
    dots[currentVideoIndex - 1].classList.add('active');
  }

  function currentVideo(n) {
    currentVideoIndex = n;
    $video.src = videoUrls[currentVideoIndex - 1];
    updateDots();
  }

  function changeVideo(n) {
    currentVideoIndex += n;
    // Wrap around to the first video
    if (currentVideoIndex > videoUrls.length) currentVideoIndex = 1;
    // Wrap around to the last video
    if (currentVideoIndex < 1) currentVideoIndex = videoUrls.length;
    currentVideo(currentVideoIndex);
  }

  $section
    .querySelectorAll('[data-change-video]')
    ?.forEach(($button) => {
      const value = parseInt($button.dataset.changeVideo, 10);
      $button.addEventListener('click', () => changeVideo(value));
    });

  $section
    .querySelectorAll('[data-current-video]')
    ?.forEach(($button) => {
      const value = parseInt($button.dataset.currentVideo, 10);
      $button.addEventListener('click', () => currentVideo(value));
    });
};
